
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/quotespot/privacy-policy",
      function () {
        return require("private-next-pages/quotespot/privacy-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/quotespot/privacy-policy"])
      });
    }
  